var map = {
	"./ar.json": "af08",
	"./de.json": "6ce2",
	"./el.json": "f184",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./id.json": "210c",
	"./it.json": "0825",
	"./ja.json": "0423",
	"./nl.json": "a625",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./sk.json": "3da9",
	"./sq.json": "eb5e",
	"./sv.json": "4c5b",
	"./sw.json": "0e32",
	"./uz.json": "7500"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";